import { Injectable } from '@angular/core';
import { signal } from '@angular/core';
import { Cliente } from '@shared/models/cliente/Cliente';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments';
import { ClienteEncabezado } from '@shared/models/cliente/ClienteEncabezado';
import { ClienteConfiguracionIATA } from '@shared/models/cliente/clienteIataDTO';
import { Observable } from 'rxjs';

export enum TipoCuenta {
  Solicitante,
  Imputacion
}
@Injectable({
  providedIn: 'root'
})
export class IATAService {
  
  baseURL = environment.apiServer.clientesBaseUrl
  private clienteURL = this.baseURL + '/ClientesV1';
  private clienteV2URL = this.baseURL + '/ClientesV2';

  // Señal para almacenar la configuración seleccionada
  configuracionSeleccionada = signal<ClienteConfiguracionIATA | null>(null);
  cuentasSolicitante = signal<Cliente | null>(null);
  cuentasImputante = signal<Cliente | null>(null);
  clientes = signal<ClienteEncabezado[] | null>([]);
  configuraciones: ClienteConfiguracionIATA[];

  constructor(
    private httpClient: HttpClient
    ) {}

  // Método para actualizar la configuración seleccionada
  setConfiguracion(configuracion: ClienteConfiguracionIATA) {
    this.configuracionSeleccionada.set(configuracion);
  }

  // Método para limpiar la configuración seleccionada
  limpiarConfiguracion() {
    this.configuracionSeleccionada.set(null);
  }

  obtenerClientesSolicitantes(): Observable<ClienteConfiguracionIATA[]> {
    return this.httpClient.get<ClienteConfiguracionIATA[]>(this.clienteV2URL + "/ClientesIATANivelDosTres");
  }

  putCuentasConfiguracionIATA(configuracion: ClienteConfiguracionIATA): Observable<ClienteConfiguracionIATA> {
    return this.httpClient.put<ClienteConfiguracionIATA>(this.clienteV2URL + "/ClienteIATANivelDosTres", configuracion)
  }
  
  postNuevaConfiguración(configuracion: ClienteConfiguracionIATA): Observable<ClienteConfiguracionIATA> {
    return this.httpClient.post<ClienteConfiguracionIATA>(this.clienteV2URL + "/ClienteIATANivelDosTres", configuracion)
  }

  setConfiguraciones(configuraciones) {
    this.configuraciones = configuraciones;
  }

  getConfiguraciones() {
    return this.configuraciones;
  }

  async setDataPorTipoCuenta(tipoDocumento: number, numeroDocumento: string, solicitante: boolean ) {
    try {
      const response = await this.httpClient.get<Cliente>(this.clienteURL + '/Clientes/numeroDocumento?tipoDocumento=' + tipoDocumento + '&numeroDocumento=' + numeroDocumento).toPromise();
      solicitante? this.cuentasSolicitante.set(response) : this.cuentasImputante.set(response)
      return response;
    } catch (error) {
      solicitante ? this.cuentasSolicitante.set(null) : this.cuentasImputante.set(null)
    }    
  }

}
